// Stabiele sleutel voor rijen in bewerkbare lijsten (factuurlijnen, prijslijnen…).
// Met de index als sleutel hertekent React de verkeerde rij zodra er een rij
// tussenuit valt; met een eigen id blijft elke rij bij haar eigen invoervakken.
let seq = 0;
export const uid = () => `r${Date.now().toString(36)}${(seq++).toString(36)}`;

export const withUid = (rows = []) => rows.map((r) => (r && r._uid ? r : { ...r, _uid: uid() }));
